import { Popover as PopoverPrimitive } from "radix-ui";
import type { ComponentPropsWithRef } from "react";

import { appConfig } from "@/config/app";
import { cx } from "@/lib/cx";

import floating from "./Floating.module.css";
import styles from "./Popover.module.css";

export const Popover = PopoverPrimitive.Root;
export const PopoverTrigger = PopoverPrimitive.Trigger;
export const PopoverClose = PopoverPrimitive.Close;
export const PopoverAnchor = PopoverPrimitive.Anchor;

/** Non-modal floating panel anchored to its trigger. Escape or a click outside closes it. */
export function PopoverContent({
  className,
  sideOffset = appConfig.overlayOffsetPx,
  align = "start",
  ...props
}: ComponentPropsWithRef<typeof PopoverPrimitive.Content>) {
  return (
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Content
        sideOffset={sideOffset}
        align={align}
        collisionPadding={appConfig.overlayOffsetPx}
        className={cx(floating.panel, styles.popover, "animate-in", className)}
        {...props}
      />
    </PopoverPrimitive.Portal>
  );
}
